module.exports = __webpack_public_path__ + "img/model2.2be8f78c.png";